module.exports = __webpack_public_path__ + "static/media/rizee_bs.4d5fbf1d.png";